import React, { useState } from "react";
import styled from "styled-components";
import bg from "../../images/auth-bg.svg";
import signin from "../../images/signin.svg";
import lock from "../../images/lock.svg";
import { UseAuthContext } from "../../store/contexts/auth.context";
import { NavLink } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";

function ForgotPassword() {
  const [sent, setsent] = useState(false);
  const [errors, seterrors] = useState({
    email: null,
    code: null,
    password: null,
  });
  const [verify, setverify] = useState(true);
  const [email, setemail] = useState();
  const { checkEmail, sendCode, verifyCode, changePassword } = UseAuthContext();
  const emailHandler = async (e) => {
    e.preventDefault();
    if (email) {
      const res = await verifyCode(email, e.target.code.value);
      if (res) {
        setverify(false);
      } else {
        seterrors({ ...errors, code: "Invalid Code" });
      }
    } else {
      try {
        const verified = await checkEmail(e.target.email.value);
        if (verified) {
          console.log(verified);
          setemail(e.target.email.value);
          seterrors({ email: null, code: null });
          const sendcode = await sendCode(e.target.email.value);
          console.log(sendcode);
        } else {
          seterrors({ email: true, code: null });
        }
      } catch (e) {
        seterrors({ email: true, code: null });
      }
    }
  };

  const recoveryPassword = async (e) => {
    e.preventDefault();
    if (e.target.password.value === e.target.confirmPassword.value) {
      const res = await changePassword(email, e.target.password.value);
      if (res) {
        setsent(true);
      }
    } else {
      seterrors({
        ...errors,
        code: "Password is not valid! (Password and Confirm Password must be same, and must be at least 5 characters)",
      });
    }
  };

  return (
    <AuthWrapper bg={bg}>
      {verify ? (
        <>
          {!email && (
            <Wrapper>
              <div>
                <h1>Recover your email</h1>
                <form onSubmit={emailHandler}>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className="form-input"
                  />
                  {errors.email && <small>Email is wrong!</small>}
                  <input
                    type="submit"
                    value="Check Email"
                    className="form-input"
                  />
                </form>
              </div>
            </Wrapper>
          )}
          {email && (
            <Wrapper>
              <div>
                <h1>Recover your email</h1>
                <form onSubmit={emailHandler}>
                  <input
                    type="text"
                    name="code"
                    placeholder="AA-000"
                    className="form-input"
                  />
                  {errors.code && <small>Code is wrong!</small>}
                  <input
                    type="submit"
                    value="Check Code"
                    className="form-input"
                  />
                </form>
              </div>
            </Wrapper>
          )}
        </>
      ) : (
        <Wrapper>
          <div>
            <h1>
              {sent ? (
                <>Password Changed Successfully!</>
              ) : (
                <>Enter new password!</>
              )}
            </h1>
            {!sent && (
              <form autoComplete="off" onSubmit={recoveryPassword}>
                <input
                  type="password"
                  name="password"
                  placeholder="New password"
                  className="form-input"
                />
                {errors.email && <small>Munimum 5 charachter!</small>}
                <input
                  type="password"
                  name="confirmPassword"
                  className="form-input"
                  placeholder="Reenter new password"
                />
                {errors.code && <small>Password is not same or valid!</small>}
                <input
                  type="submit"
                  value="Set new password"
                  className="form-input"
                />
              </form>
            )}
            {sent && (
              <NavLink to={"/signin"}>
                <input
                  type="button"
                  value="Sign In Now!"
                  className="form-input"
                />
              </NavLink>
            )}
          </div>
        </Wrapper>
      )}
    </AuthWrapper>
  );
}

export default ForgotPassword;

const Wrapper = styled.main`
  & > div {
    width: auto !important;
    border: 0 !important;
    max-width: 420px;
    padding-top: 60px !important;
    margin-left: 0 !important;
  }
  form {
    width: 100% !important;
  }
  small {
    font-size: 14px;
    margin-top: -12px !important;
    margin-bottom: 6px !important;
  }
`;
